<template>
    <div class="container notification-view layout-max-width mt-lg-3">
        <heading title="Notifications">
           <b-button class="ml-3" to="/notifications/custom">Create Custom Notification</b-button>
        </heading>
        <b-tabs pills vertical class="pt-3">
            <!-- Inbox Tab -->
            <b-tab title="Inbox">
                <data-table ref="inboxTable"
                            :defaultItemsPerPage="10"
                            :show-filters="true"
                            :show-pager="true"
                            :get-items="getInbox"
                            v-model="inboxFilters"
                            :fields="inboxFields">
                    <template v-slot:customField="slotProps">
                        <div v-if="slotProps.row.field.key === 'message'">
                            <span v-html="truncate(slotProps.row.item.message)"/>
                        </div>
                        <div v-else-if="slotProps.row.field.key === 'created'">
                            <timestamp :date="slotProps.row.item.created"/>
                        </div>
                        <div v-else-if="slotProps.row.field.key === 'actions'">
                            <div class="d-flex">
                                <button class="btn btn-secondary btn-sm mr-2 btn-icon"
                                        @click="viewNotification(slotProps.row.item)">
                                    <b-icon-eye/>
                                </button>
                                <button class="btn btn-danger btn-sm mr-2 btn-icon"
                                        @click="deleteNotification(slotProps.row.item)">
                                    <b-icon-trash/>
                                </button>
                            </div>
                        </div>
                    </template>
                </data-table>
            </b-tab>

            <!-- Hidden Tab -->
            <b-tab title="Hidden">
                <data-table ref="hiddenTable"
                            :defaultItemsPerPage="10"
                            :show-filters="true"
                            :show-pager="true"
                            :get-items="getHidden"
                            v-model="hiddenFilters"
                            :fields="hiddenFields">
                    <template v-slot:customField="slotProps">
                        <div v-if="slotProps.row.field.key === 'message'">
                            <span v-html="truncate(slotProps.row.item.message)"/>
                        </div>
                        <div v-else-if="slotProps.row.field.key === 'created'">
                            <timestamp :date="slotProps.row.item.created"/>
                        </div>
                        <div v-else-if="slotProps.row.field.key === 'actions'">
                            <button class="btn btn-secondary btn-sm mr-2 btn-icon"
                                    @click="viewNotification(slotProps.row.item)">
                                <b-icon-eye/>
                            </button>
                            <button class="btn btn-secondary btn-success btn-sm mr-2 btn-icon"
                                    @click="restoreNotification(slotProps.row.item)">
                                <b-icon-inbox-fill/>
                            </button>
                        </div>
                    </template>
                </data-table>
            </b-tab>
        </b-tabs>

        <notification-view-modal
            :notification="notification"
            modalId="viewNotificationModal"/>
    </div>
</template>

<script>
import Vue from 'vue'
import Heading from "@/components/Heading";

export default Vue.extend({
    name: 'NotificationView',
    components: {Heading},
    data () {
        return {
            inboxFields: [
                { key: 'message', label: 'Message' },
                { key: 'status', sortable: true, label: 'Read' },
                { key: 'created', sortable: true, label: 'Received' },
                { key: 'actions' }
            ],
            hiddenFields: [
                { key: 'message', label: 'Message' },
                { key: 'created', sortable: true, label: 'Received' },
                { key: 'actions' }
            ],
            notification: {},
            inboxFilters: {
                currentNotificationsForId: {
                    field: 'currentNotificationsForId',
                    type: 'hidden',
                    value: this.$user.userId()
                },
                message: { field: 'message', type: 'string', value: null, label: 'Message' },
                status: { field: 'status', type: 'select', options: ['READ', 'UNREAD'], label: 'Read' }
            },
            hiddenFilters: {
                hiddenNotificationsForId: {
                    field: 'hiddenNotificationsForId',
                    type: 'hidden',
                    value: this.$user.userId()
                },
                message: { field: 'message', type: 'string', value: null, label: 'Message' },
            },
        }
    },
    methods: {
        async getInbox (sort) {
            return await this.$api.getItems(this, 'notification', this.inboxFilters, sort, ['equipment'])
        },
        async getHidden (sort) {
            return await this.$api.getItems(this, 'notification', this.hiddenFilters, sort, ['equipment'])
        },
        async viewNotification (notification) {
            this.$bvModal.show('viewNotificationModal')
            this.notification = notification
            if (notification.status === 'UNREAD') {
                notification.status = 'READ'
                await this.$api.updateItem(this, 'notification', notification)
                this.refresh()
            }
        },
        truncate (str, length = 32, end = '...') {
            return str.length > length ? str.substring(0, length - end.length) + end : str
        },
        deleteNotification: async function (notification) {
            this.$bvModal.msgBoxConfirm('Are you sure you would like to hide this notification?')
                .then(async value => {
                    if (value) {
                        notification.status = 'HIDDEN'
                        await this.$api.updateItem(this, 'notification', notification)
                        this.refresh()
                    }
                })

        },
        restoreNotification: async function (notification) {
            this.$bvModal.msgBoxConfirm('Would you like to unhide this notification?')
                .then(async value => {
                    if (value) {
                        notification.status = 'READ'
                        await this.$api.updateItem(this, 'notification', notification)
                        this.refresh()
                    }
                })
        },
        refresh () {
            this.$refs.inboxTable.refresh()
            this.$refs.hiddenTable.refresh()
        }
    },
})
</script>
